module.exports = "//static.hsappstatic.net/LoginUI/static-1.14169/img/SUI_desktop.svg"